import React from 'react';
import clsx from 'clsx';
import {NavLink} from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography  from '@material-ui/core/Typography';
import Drawer from '@material-ui/core/Drawer';
import OutboundIcon from '@mui/icons-material/Outbound';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import LockIcon from '@mui/icons-material/Lock';
import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaper: {
    marginTop: '62px',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
  
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  drawerList: {
    paddingTop:0,
    paddingBottom: 0
  },
  drawerButton: {
    paddingTop:'15px',
    paddingBottom: '15px',
    "&.active": {
      background:'rgba(0,0,0,.2)',
    },
  },
  disabledIcon: {
    display: 'contents',
    color: '#d41e11',
    '& svg':{
      height: '0.8em',
      width: '0.8em'
    }
  },
  disablednested: {
    paddingLeft: theme.spacing(2),
    paddingTop:'12px',
    paddingBottom: '12px',
    cursor: 'not-allowed'
  },
}));
export default function Nav(props) {
    const classes = useStyles();

    return (<>
        <CssBaseline />
        <AppBar position="absolute" className={clsx(classes.appBar, false && classes.appBarShift)}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              IT Portal
            </Typography>
            <Button color="inherit">Logout</Button>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" classes={{ paper: clsx(classes.drawerPaper, !true && classes.drawerPaperClose),}} open={true}>
            <List className={classes.drawerList}>
                {props.role.account.idToken.roles[0] === "BulkUpdate" ?
                  <ListItem className={classes.disablednested}>
                    <ListItemIcon className={classes.drawerIcon}>
                        <OutboundIcon />
                    </ListItemIcon>
                    <ListItemText primary="Loans/Returns" />
                    <ListItemIcon className={classes.disabledIcon}>
                        <LockIcon />
                    </ListItemIcon>
                  </ListItem> :
                  <ListItem button className={classes.drawerButton} component={NavLink} to="/Loans">
                    <ListItemIcon className={classes.drawerIcon}>
                        <OutboundIcon />
                    </ListItemIcon>
                    <ListItemText primary="Loans/Returns" />
                  </ListItem>
                }
            </List>
            <List className={classes.drawerList}>
              {props.role.account.idToken.roles[0] !== "BulkUpdate" && props.role.account.idToken.roles[0] !== "AllPerms" ?
                  <ListItem className={classes.disablednested}>
                    <ListItemIcon className={classes.drawerIcon}>
                        <OutboundIcon />
                    </ListItemIcon>
                    <ListItemText primary="Bulk Device/Asset Update" />
                    <ListItemIcon className={classes.disabledIcon}>
                        <LockIcon />
                    </ListItemIcon>
                  </ListItem> :
                  <ListItem button className={classes.drawerButton} component={NavLink} to="/BulkUpdate">
                    <ListItemIcon className={classes.drawerIcon}>
                        <SystemUpdateAltIcon />
                    </ListItemIcon>
                    <ListItemText primary="Bulk Asset Update" />
                  </ListItem>
                }
            </List>
            <List className={classes.drawerList}>
              {props.role.account.idToken.roles[0] !== "BulkJobUpdate" && props.role.account.idToken.roles[0] !== "AllPerms" ?
                  <ListItem className={classes.disablednested}>
                    <ListItemIcon className={classes.drawerIcon}>
                        <OutboundIcon />
                    </ListItemIcon>
                    <ListItemText primary="Bulk Hornbill Job" />
                    <ListItemIcon className={classes.disabledIcon}>
                        <LockIcon />
                    </ListItemIcon>
                  </ListItem> :
                  <ListItem button className={classes.drawerButton} component={NavLink} to="/BulkHornbillJob">
                    <ListItemIcon className={classes.drawerIcon}>
                        <SystemUpdateAltIcon />
                    </ListItemIcon>
                    <ListItemText primary="Bulk Hornbill Job" />
                  </ListItem>
                }
            </List>
        </Drawer>
      </>
    )
}